const CLASSES = {
    body: 'PREVENT_USER_SCROLL',
    html: 'PREVENT_USER_SCROLL--html',
};

function measureScrollBar() {
    const scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    scrollDiv.remove();
    return scrollbarWidth;
}

function setScrollBarOffset(padInt) {
    document.body.style.paddingRight = `${padInt}px`;
}

function resetScrollBarOffset() {
    delete document.body.style.paddingRight;
}

export function allowUserScroll() {
    resetScrollBarOffset();
    document.body.classList.remove(CLASSES.body);
    document.querySelector('html').classList.remove(CLASSES.html);
}

export function preventUserScroll() {
    setScrollBarOffset(measureScrollBar());
    document.body.classList.add(CLASSES.body);
    document.querySelector('html').classList.add(CLASSES.html);
}

export function toggleUserScroll() {}
